function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_232",
  "data-name": "Rectangle 232",
  width: 30,
  height: 30,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1051",
  "data-name": "Path 1051",
  d: "M22992.82,18277.994a1.826,1.826,0,0,1-1.82-1.822v-14.541a1.822,1.822,0,0,1,1.82-1.818h9.084v1.818h-8.174a.912.912,0,0,0-.91.91v12.723a.909.909,0,0,0,.91.908h12.721a.908.908,0,0,0,.914-.908v-8.172h1.82v9.08a1.826,1.826,0,0,1-1.82,1.822Zm2.727-3.637a.91.91,0,1,1,0-1.82h9.092a.91.91,0,0,1,0,1.82Zm0-3.633a.912.912,0,0,1,0-1.824h9.092a.912.912,0,0,1,0,1.824Zm0-3.641a.908.908,0,1,1,0-1.816h4.547a.908.908,0,1,1,0,1.816Zm13.719-1.855-1.9-1.041-1.9,1.041a.287.287,0,0,1-.148.039.328.328,0,0,1-.316-.391l.363-2.213-1.537-1.57a.339.339,0,0,1,.174-.57l2.131-.322.949-2.014a.316.316,0,0,1,.285-.191.309.309,0,0,1,.283.191l.955,2.014,2.127.322a.338.338,0,0,1,.172.57l-1.537,1.57.361,2.213a.325.325,0,0,1-.311.391A.293.293,0,0,1,23009.266,18265.229Z",
  transform: "translate(-22985.998 -18253)",
  fill: "#fff"
});

function SvgIconMyCases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_MyCases",
    "data-name": "icon/MyCases",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyCases);
export default __webpack_public_path__ + "static/media/iconMyCases.46704078.svg";
export { ForwardRef as ReactComponent };